module.exports = __webpack_public_path__ + "img/finance_8.90bb0b45.png";